import { FETCH_Booking_DATA, FETCH_DASHBOARD_DATA, FETCH_HostelAndCourse_DATA, FETCH_Visitor_DATA } from "../../config/adminUrlConfig";
import { ApiService } from "../../config/apiServices";

 export const getDashboardData = () => {
  return ApiService.get(FETCH_DASHBOARD_DATA);
};
  export const getBookingData = () => {
  return ApiService.get(FETCH_Booking_DATA);
};
  export const getHostelAndCourseData = () => {
  return ApiService.get(FETCH_HostelAndCourse_DATA);
};
  export const getVisitorData = (filter = "year") => {
  return ApiService.get(`${FETCH_Visitor_DATA}?filterValue=${filter}`);
};